import styled from "styled-components";

export const LearnPanel = styled.section`
  grid-area: learn;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  margin-top: 15px;
`;
